import React, { useMemo } from 'react';
import CameraViewWidget from './Components/CameraPane/CameraViewWidget';
import PropertyViewWidget from './Components/PropertyPane/PropertyViewWidget';
import { CAMERA_TOP_SECTION_LAYOUT_CONTEXTS } from './Components/CameraPane/cameraViewHelpers';
import styles from './TopSection.module.css';

type TopSectionProps = {
    shouldRender: boolean;
    spotUuid: string;
    spotLatitude: string;
    spotLongitude: string;
    isDemoMode: boolean;
    isPropertyViewVisible: boolean;
    onPropertyViewVisibilityChange: (isVisible: boolean) => void;
};

function TopSection({
    shouldRender,
    spotUuid,
    spotLatitude,
    spotLongitude,
    isDemoMode,
    isPropertyViewVisible,
    onPropertyViewVisibilityChange,
}: TopSectionProps): JSX.Element | null {
    const topSectionLayoutContext = useMemo(
        () =>
            isPropertyViewVisible
                ? CAMERA_TOP_SECTION_LAYOUT_CONTEXTS.SPLIT
                : CAMERA_TOP_SECTION_LAYOUT_CONTEXTS.FULL_WIDTH,
        [isPropertyViewVisible]
    );

    if (!shouldRender) {
        return null;
    }

    return (
        <section className={styles.section} data-testid="visibility-top-section">
            <div className={styles.topSplitRow} data-testid="visibility-top-split-row">
                <div className={`${styles.topSplitSlot} ${styles.propertySlot}`} data-testid="visibility-property-slot">
                    <PropertyViewWidget
                        spotUuid={spotUuid}
                        spotLatitude={spotLatitude}
                        spotLongitude={spotLongitude}
                        isDemoMode={isDemoMode}
                        onVisibilityChange={onPropertyViewVisibilityChange}
                    />
                </div>
                <div className={styles.topSplitSlot} data-testid="visibility-camera-slot">
                    <CameraViewWidget
                        spotUuid={spotUuid}
                        isDemoMode={isDemoMode}
                        topSectionLayoutContext={topSectionLayoutContext}
                    />
                </div>
            </div>
        </section>
    );
}

export default TopSection;
